/**
 * start-algorithm-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link StartAlgorithmRequest} when it wishes to begin
 * executing an algorithm. If the algorithm could not be started, then the
 * server replies with a {@link AcknowledgmentResponse} serving as a negative
 * acknowledgment. If the algorithm can be started successfully, then the
 * server replies with a positive acknowledgment. Afterward the client may
 * receive {@link NextStepsResponse}s that identify {@link IntakeStep intake}
 * and {@link ReportStep report} steps to present.
 */
export class StartAlgorithmRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_START_ALGORITHM;
	public static tag : MessageTag = MessageTag.REQ_START_ALGORITHM;

  /**
   * Construct a new {@link StartAlgorithmRequest}.
   *
   * @param name
   *        The name of the target algorithm.
   */
  constructor (
    private name : string,
    public objectId : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/start-algorithm-request.ts